// assets
import {
  IconFileInvoice,
  IconReceipt2,
  IconChartHistogram,
  IconPhoneCall,
} from '@tabler/icons-react';

// constant
const icons = {
  IconFileInvoice,
  IconReceipt2,
  IconChartHistogram,
  IconPhoneCall,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const offices = {
  id: 'offices',
  title: 'Office Management',
  type: 'group',
  access: ['super_admin', 'admin', 'user'],
  children: [
    {
      id: 'conveyances',
      title: 'Conveyances',
      type: 'collapse',
      color: '#0C356A',
      icon: icons.IconFileInvoice,
      access: ['super_admin', 'admin', 'user'],
      children: [
        {
          id: 'my-conveyances',
          title: 'My Conveyances',
          type: 'item',
          url: '/offices/conveyances/my-conveyances',
          access: ['admin', 'user'],
        },
        {
          id: 'pending-conveyances',
          title: 'Pending Conveyances',
          type: 'item',
          url: '/offices/conveyances/pending-conveyances',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'all-conveyances',
          title: 'All Conveyances',
          type: 'item',
          url: '/offices/conveyances/all-conveyances',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'conveyance-library',
          title: 'Library',
          type: 'item',
          url: '/offices/conveyances/conveyance-library',
          access: ['super_admin', 'admin'],
        },
      ],
    },
    {
      id: 'bills',
      title: 'Bills',
      type: 'collapse',
      color: '#0C356A',
      icon: icons.IconReceipt2,
      access: ['super_admin', 'admin', 'user'],
      children: [
        {
          id: 'my-bills',
          title: 'My Bills',
          type: 'item',
          url: '/offices/bills/my-bills',
          access: ['admin', 'user'],
        },
        {
          id: 'pending-bills',
          title: 'Pending Bills',
          type: 'item',
          url: '/offices/bills/pending-bills',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'all-bills',
          title: 'All Bills',
          type: 'item',
          url: '/offices/bills/all-bills',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'bill-library',
          title: 'Library',
          type: 'item',
          url: '/offices/bills/bill-library',
          access: ['super_admin', 'admin'],
        },
      ],
    },
    {
      id: 'manage-mobile-bill',
      title: 'Manage Mobile Bill',
      type: 'collapse',
      color: '#0C356A',
      icon: icons.IconPhoneCall,
      access: ['super_admin', 'admin'],
      children: [
        {
          id: 'mobile-bills',
          title: 'Mobile Bills',
          type: 'item',
          url: '/offices/manage-mobile-bill/mobile-bills',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'mobile-no-list',
          title: 'Mobile No. List',
          type: 'item',
          url: '/offices/manage-mobile-bill/mobile-no-list',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'mobile-no-user',
          title: 'Mobile No. User',
          type: 'item',
          url: '/offices/manage-mobile-bill/mobile-no-user',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'monthly-receipt',
          title: 'Monthly Receipt',
          type: 'item',
          url: '/offices/manage-mobile-bill/monthly-receipt',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'user-bill-summary',
          title: 'User Bill Summary',
          type: 'item',
          url: '/offices/manage-mobile-bill/user-bill-summary',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'mobile-no-summary',
          title: 'Mobile No. Summary',
          type: 'item',
          url: '/offices/manage-mobile-bill/mobile-no-summary',
          access: ['super_admin', 'admin'],
        },
      ],
    },
    {
      id: 'report',
      title: 'Report',
      type: 'collapse',
      color: '#0C356A',
      icon: icons.IconChartHistogram,
      access: ['super_admin', 'admin'],
      children: [
        {
          id: 'expense-summary',
          title: 'Expense Summary',
          type: 'item',
          url: '/offices/report/expense-summary',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'month-summary',
          title: 'Monthly Expense',
          type: 'item',
          url: '/offices/report/month-summary',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'conveyance-summary',
          title: 'Conveyance Summary',
          type: 'item',
          url: '/offices/report/conveyance-summary',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'bill-summary',
          title: 'Bill Summary',
          type: 'item',
          url: '/offices/report/bill-summary',
          access: ['super_admin', 'admin'],
        },
      ],
    },
  ],
};

export default offices;
